import { Component, ViewChild, ElementRef } from '@angular/core';
import { AlertController, ToastController } from 'ionic-angular';
import { LoggerProvider, LoggerEvent } from '../../providers/logger/logger';
import { RouteProvider } from '../../providers/route/route';
import { ErrorCodeType } from '../../model/types/error-code-type';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'rmt-popup',
  templateUrl: 'rmt-popup.html'
})
export class RmtPopupComponent {
  @ViewChild('container', { read: ElementRef }) container;
  static popups = [];
  static shadowOpacity = 1.0;
  static durationQuick = 1000;
  static alertCtrl;
  static toastCtrl;
  static route;
  static translateService;

  constructor(private alertCtrl: AlertController,
              private route: RouteProvider,
              private toastCtrl: ToastController,
              private translateService: TranslateService) {
    RmtPopupComponent.alertCtrl = this.alertCtrl;
    RmtPopupComponent.toastCtrl = this.toastCtrl;    
    RmtPopupComponent.route = this.route;
    RmtPopupComponent.translateService = this.translateService;
  }

  ngAfterViewInit() {
    this.container.nativeElement.parentNode.removeChild(this.container.nativeElement);
    document.getElementsByTagName('ion-app')[0].appendChild(this.container.nativeElement);
  }

  hasPopups() {
    if (RmtPopupComponent.popups && RmtPopupComponent.popups.length > 0)
      return true;
    return false;
  }

  getPopups() {
    return RmtPopupComponent.popups;
  }

  getShadowOpacity() {
    return RmtPopupComponent.shadowOpacity;
  }

  hidePopup(popup) {
    RmtPopupComponent.hidePopup(popup);
  }

  static showToast(title: string, duration: number = 0) {
    if (duration === 0)
      duration = 3000;
    const toast = RmtPopupComponent.toastCtrl.create({
      message: title,
      duration: duration,
    });
    toast.present();
  }

  static showSuccess(title: string, duration: number = 0) {
    if (duration === 0)
      duration = 3000;
    const toast = RmtPopupComponent.toastCtrl.create({
      message: title,
      duration: duration,
      cssClass: 'toast-success'
    });
    toast.present();
  }
/**
 * 
 *  message?: string;
    cssClass?: string;
    duration?: number;
    showCloseButton?: boolean;
    closeButtonText?: string;
    dismissOnPageChange?: boolean;
    position?: string;
 */
  static showToastWithAction(title:string,closeText:string,callBackAction, duration: number = 0){
    if(duration === 0)
      duration = 3000;
    const toast = RmtPopupComponent.toastCtrl.create({
      message: title,
      duration: duration,
      showCloseButton: true,
      closeButtonText:closeText,
      cssClass: 'toast-action'
    });
    toast.present();
    toast.onDidDismiss((data,role)=>{
      if(role==='close')
        callBackAction();
    });
  }
  static showCancel (title: string, duration: number = 0) {
    if (duration === 0)
      duration = 3000;
    const toast = RmtPopupComponent.toastCtrl.create({
      message: title,
      duration: duration,
      cssClass: 'toast-cancel'
    });
    toast.present();
  }
  static showToastWithPointDown(title: string, duration: number = 0){
    if (duration === 0)
    duration = 3000;
  const toast = RmtPopupComponent.toastCtrl.create({
    message: title,
    duration: duration,
    showCloseButton:false,
    cssClass: 'toast-wallet-activate'
  });
  toast.present();
  
  }

  static showSuccessMessage(message: string, title: string = null, duration: number = 0) {
    return RmtPopupComponent.showPopup(message, true, title, duration);
  }

  static showError(title: string) {
    this.showErrorMessage(null, title);
  }

  static showErrorMessage(message: string, title: string = null, log: boolean = true, messageHtml = null) {
    if (log) {
      let logmsg = title;
      if (logmsg && logmsg.length > 0)
        logmsg += ' / ';
      logmsg += message;
      LoggerProvider.error(this, LoggerEvent.Popup, logmsg);
    }

    // delay it one frame if an eventual transition will take place
    window.requestAnimationFrame(() => {
      this.showErrorMessageAsync(message, title, messageHtml);
    });
  }

  static showErrorWithLogTranslation(titleKey: string) {
    this.showErrorMessageWithLogTranslation(null, titleKey);
  }

  static showErrorMessageWithLogTranslation(messageKey: string="", titleKey: string = null,  messageHtml = null) {
      const message = messageKey && this.translateService.instant(messageKey) || "";
      const title = titleKey && this.translateService.instant(titleKey) || null;
      let messageTranslated = message;
      let titleTranslated = title;
      ({ messageTranslated, titleTranslated } = RmtPopupComponent.showExceptionLogRoutine(
        messageTranslated, messageKey, titleTranslated, titleKey));
      
      let logmsg = titleTranslated;
      
      if (logmsg && logmsg.length > 0)
        logmsg += ' / ';
      logmsg += messageTranslated;
      LoggerProvider.error(this, LoggerEvent.Popup, logmsg);

    // delay it one frame if an eventual transition will take place
    window.requestAnimationFrame(() => {
      this.showErrorMessageAsync(message, title, messageHtml);
    });
  }

  static async showErrorMessageAsync(message: string, title: string, messageHtml = null) {
    // otherwise the alert dialog might get hidden behind a new page
    await this.route.waitForTransitions();

    const alert = this.alertCtrl.create({
      cssClass: 'popup-error',
      message: '<div class="alert-error"><div class="alert-error-icon"></div></div>',
      buttons: [{
        text: this.translateService.instant('global.gotItButton'),
        role: 'cancel'
      }]
    });
    if (title && !message && !messageHtml) {
      message = title;
      title = this.translateService.instant('global.errorText');
    }

    alert.setMode('ios');
    const promise = alert.present();
    let error;
    const addContent: any = () => {
      const popups = document.getElementsByClassName('popup-error');
      if(popups.length > 0) {
        const popup = popups[popups.length - 1];
        error = popup.getElementsByClassName('alert-error')[0];
      }
      if (!error)
        return false;

      if (title) {
        const titleel = document.createElement('h5');
        titleel.innerText = title;
        error.appendChild(titleel);
      }
      if (messageHtml) {
        const messageel = document.createElement('div');
        messageel.appendChild(messageHtml);
        error.appendChild(messageel);
      }
      else if (message) {
        const messageel = document.createElement('h6');
        messageel.innerHTML = message;
        error.appendChild(messageel);
      }
      return true;
    };

    window.setTimeout(() => {
      // if it can't be added right now, add it when the alert dialog is presented which looks less fluid
      if (!addContent())
        promise.then(() => {
          addContent();
        });
    }, 250);
  }

  static showException(origin, exception, message: string, title: string = null, messageHtml = null) {
    if (origin && exception) {
      let logmsg = message;
      if (!logmsg)
        logmsg = title;
      LoggerProvider.exception(origin, exception, LoggerEvent.Popup, logmsg);
    }
    if (!exception || exception.errorCode !== ErrorCodeType.ConnectionError) // if the error code is a timeout then an error has been displayed already otherwise we will spam the screen with message boxes
      this.showErrorMessage(message, title, false, messageHtml);
  }

  static showExceptionWithLogTranslation(origin, exception, messageKey: string, titleKey: string = null, messageHtml = null) {
    const message = messageKey && this.translateService.instant(messageKey) || "";
    const title =titleKey && this.translateService.instant(titleKey) || null;
    let messageTranslated = message;
    let titleTranslated = title;

    ({ messageTranslated, titleTranslated } = RmtPopupComponent.showExceptionLogRoutine(
      messageTranslated, messageKey, titleTranslated, titleKey));

    if (origin && exception) {
      let logmsg = messageTranslated;
      if (!logmsg)
        logmsg = titleTranslated;
      LoggerProvider.exception(origin, exception, LoggerEvent.Popup, logmsg);
    }
    if (!exception || exception.errorCode !== ErrorCodeType.ConnectionError) // if the error code is a timeout then an error has been displayed already otherwise we will spam the screen with message boxes
      this.showErrorMessage(message, title, false, messageHtml);
  }

  private static showExceptionLogRoutine(messageTranslated: any = "", messageKey: string, titleTranslated: any = "", titleKey: string) {
    const currentLang = this.translateService.currentLang;
    if (currentLang != "en_US") {
      this.translateService.use("en_US");
      if (messageKey && messageKey.length > 0) {
        messageTranslated = this.translateService.instant(messageKey);
      }
      if (titleKey && titleKey.length > 0) {
        titleTranslated = this.translateService.instant(titleKey);
      }
      this.translateService.use(currentLang);
    }
    return { messageTranslated, titleTranslated };
  }

  static showPopup(message: string, success: boolean, title: string = null, duration: number = 0) {
    if (!title) {
      if (success)
        title = 'Success';
      else
        title = 'Failed';
    }
    if (duration === 0) {
      if (success)
        duration = 1000;
      else
        duration = 200000;

      if (message && message.length > 10)
        duration += 1000;
      if (message && message.length > 20)
        duration += 1000;
    }
    RmtPopupComponent.shadowOpacity = 1.0;
    const popup = { message: message, success: success, title: title, opacity: 1.0, timeout: null };
    if (duration > 0) {
      popup.timeout = window.setTimeout(() => {
        RmtPopupComponent.hidePopup(popup);
      }, duration);
    }

    RmtPopupComponent.popups.push(popup);
  }

  static hidePopup(popup) {
    if (popup.opacity === 0.0)
      return;

    if (popup.timeout)
      window.clearTimeout(popup.timeout);
    popup.timeout = null;
    popup.opacity = 0.0;

    RmtPopupComponent.shadowOpacity = 0.0;
    for (let i = 0; i < RmtPopupComponent.popups.length; i++) {
      if (RmtPopupComponent.popups[i].opacity > 0.0) {
        RmtPopupComponent.shadowOpacity = 1.0;
        break;
      }
    }
    window.setTimeout(() => {
      for (let i = 0; i < RmtPopupComponent.popups.length; i++) {
        if (RmtPopupComponent.popups[i] === popup) {
          RmtPopupComponent.popups.splice(i, 1);
          break;
        }
      }
    }, 500);
  }

  static async showMessageAsync( title: string, message: string = null, messageHtml = null) {
    // otherwise the alert dialog might get hidden behind a new page
    await this.route.waitForTransitions();

    if (title && !message && !messageHtml) {
      message = title;
      title = 'Error';
    }

    const alert = this.alertCtrl.create({
      title: title,
      cssClass: 'popup-error',
      message: messageHtml? messageHtml : message,
      buttons: [{
        text: this.translateService.instant('global.genericContinueButton'),
        role: 'cancel'
      }]
    });

    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/components/rmt-popup/rmt-popup.ts